import PetInfo from './PetInfo';
export default PetInfo;
